document.addEventListener('DOMContentLoaded', function () {
  var galleryThumbs = new Swiper('.slider-for', {
    slidesPerView: "auto",
    spaceBetween: 24,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      768: {
        slidesPerView: "auto",
      },
      320: {
        spaceBetween: 12,
        slidesPerView: 1.11,
      },
    }
  });

  var galleryTop = new Swiper('.slider-nav', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });

  function applyResponsiveSync() {
    galleryThumbs.on('slideChange', function () {
      var activeIndex = galleryThumbs.activeIndex;
      galleryTop.slideTo(activeIndex);
    });
    galleryTop.on('slideChange', function () {
      var activeIndex = galleryTop.activeIndex;
      galleryThumbs.slideTo(activeIndex);
    });
  }
  window.addEventListener('resize', applyResponsiveSync);

  applyResponsiveSync();

  window.addEventListener('resize', function () {
    galleryThumbs.update();
    galleryTop.update();
  });
});
